import { REGIONS } from 'state/intl/types';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const domainChangeByRegion = (url: string, regionKey?: REGIONS) => url;
